import { t } from '@lingui/macro';
import { Typography, makeStyles } from '@material-ui/core';
import { isNil } from 'lodash';

const useStyles = makeStyles((theme) => ({
    pathInfoText: {
        padding: '8px 16px',
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    pathInfoWrapper: {
        padding: '16px 32px 0',
        display: 'flex',
        gap: '8px',

        '& > *:nth-child(odd)': {
            borderRight: `1px solid ${theme.palette.text.primary}`,
        },
    },
}));

export function PathVisualizationInfo({ pathDelay, pathNumberOfHops, statusMessage }) {
    const styles = useStyles();

    if (statusMessage) {
        return (
            <div className={styles.pathInfoText}>
                <Typography variant="subtitle1">{t`Unable to complete path analyisis`}</Typography>
                <Typography variant="caption">{t`${statusMessage}`}</Typography>
            </div>
        );
    }

    return (
        <>
            <div className={styles.pathInfoWrapper}>
                <div className={styles.pathInfoText}>
                    <Typography variant="h6">
                        {!isNil(pathDelay) ? `${pathDelay < 1 ? '<1' : pathDelay}ms` : t`Unknown`}
                    </Typography>
                    <Typography variant="caption">{t`Path Delay`}</Typography>
                </div>
                <div className={styles.pathInfoText}>
                    <Typography variant="h6">{pathNumberOfHops || t`Unknown`}</Typography>
                    <Typography variant="caption">{t`Path Hops`}</Typography>
                </div>
            </div>
        </>
    );
}

PathVisualizationInfo.defaultProps = {
    pathDelay: null,
    pathNumberOfHops: null,
    statusMessage: null,
};
